/**
 * @fileoverview
 * @enhanceable
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

goog.exportSymbol('proto.AIAssistantLevel', null, global);
goog.exportSymbol('proto.AIAssistantType', null, global);
goog.exportSymbol('proto.AffiliateAccessLevel', null, global);
goog.exportSymbol('proto.AffiliateAgentRemarksStatus', null, global);
goog.exportSymbol('proto.AffiliateAgentRemarksSubStatus', null, global);
goog.exportSymbol('proto.AffiliateEntityType', null, global);
goog.exportSymbol('proto.AffiliatePermissionsTemplatesId', null, global);
goog.exportSymbol('proto.AlgoPermissions', null, global);
goog.exportSymbol('proto.CouponType', null, global);
goog.exportSymbol('proto.NotificaionMsgType', null, global);
goog.exportSymbol('proto.PlanType', null, global);
goog.exportSymbol('proto.PortfolioShareStatus', null, global);
goog.exportSymbol('proto.PushNotificationType', null, global);
goog.exportSymbol('proto.RetailLinkStatus', null, global);
goog.exportSymbol('proto.RiskOMeterValues', null, global);
goog.exportSymbol('proto.TimelineLogsAction', null, global);
goog.exportSymbol('proto.WebErrorCodes', null, global);
/**
 * @enum {number}
 */
proto.AlgoPermissions = {
  WEBALGOPERMISSION_EXTERNALSTRATEGY: 0,
  WEBALGOPERMISSION_NIFTY: 1,
  WEBALGOPERMISSION_BANKNIFTY: 2,
  WEBALGOPERMISSION_FINNIFTY: 3,
  WEBALGOPERMISSION_UTRADEORIGINALS: 4,
  WEBALGOPERMISSION_PAYOFFCURVE: 5,
  WEBALGOPERMISSION_MARGINCALCULATOR: 6,
  WEBALGOPERMISSION_ALLSYMBOLS: 7,
  WEBALGOPERMISSION_CONCURRENTBT: 8,
  WEBALGOPERMISSION_PUBLICPORTFOLIO: 9,
  WEBALGOPERMISSION_RELATIONSHIPMANAGER: 10,
  WEBALGOPERMISSION_CUSTOMALGOS: 11,
  WEBALGOPERMISSION_COPYALGOALLOWED: 12,
  WEBALGOPERMISSION_HIDECUSTOMPORTFOLIO: 13,
  WEBALGOPERMISSION_MIDCAPNIFTY: 14,
  WEBALGOPERMISSION_NSECM: 15,
  WEBALGOPERMISSION_NSEFO: 16,
  WEBALGOPERMISSION_BSECM: 17,
  WEBALGOPERMISSION_SENSEX: 18,
  WEBALGOPERMISSION_BANKEX: 19,
  WEBALGOPERMISSION_BSEFO: 20,
  WEBALGOPERMISSION_ALLBSESYMBOLS: 21,
  WEBALGOPERMISSION_ALLNSESYMBOLS: 22,
  WEBALGOPERMISSION_DOWNLOADUPLOADPORTFOLIO: 23,
  WEBALGOPERMISSION_DELIVERY: 24,
  WEBALGOPERMISSION_INTRADAY: 25,
  WEBALGOPERMISSION_CARRYFORWARD: 26,
  WEBALGOPERMISSION_AIASSISTANT_STRATEGIST: 27,
  WEBALGOPERMISSION_NSECM_CARRYFORWARD: 28,
  WEBALGOPERMISSION_NSEFO_CARRYFORWARD: 29,
  WEBALGOPERMISSION_BSECM_CARRYFORWARD: 30,
  WEBALGOPERMISSION_BSEFO_CARRYFORWARD: 31,
  WEBALGOPERMISSION_NSECM_INTRADAY: 32,
  WEBALGOPERMISSION_NSEFO_INTRADAY: 33,
  WEBALGOPERMISSION_BSECM_INTRADAY: 34,
  WEBALGOPERMISSION_BSEFO_INTRADAY: 35,
  WEBALGOPERMISSION_AIASSISTANT_ADVISOR: 36,
  WEBALGOPERMISSION_AIRECOMMEND_ORIGINALS: 37,
  WEBALGOPERMISSION_AIASSISTANT_ONEAI: 38,
  WEBALGOPERMISSION_AIASSISTANT_EQUITY_STRATEGIST: 39
};

/**
 * @enum {number}
 */
proto.WebErrorCodes = {
  WEBERRORCODES_INVALIDSTARTENDDATE: 0,
  WEBERRORCODES_INVALIDSTARTDATE: 1,
  WEBERRORCODES_PERMISSIONDENIED: 2,
  WEBERRORCODES_BACKTESTINGNOTALLOWED: 3,
  WEBERRORCODES_LIVTRADINGNOTALLOWED: 4,
  WEBERRORCODES_BACKTESTALREADYQUEUED: 5,
  WEBERRORCODES_MAXBACKTESTALLOWEDINAMONTH: 6,
  WEBERRORCODES_MAXBACKTESTALLOWEDPERDAY: 7,
  WEBERRORCODES_BACKTESTALLOWEDFORMONTHS: 8,
  WEBERRORCODES_PORTFOLIOCREATIONNOTALLOWED: 9,
  WEBERRORCODES_MAXPORTFOLIOLIMITBREACHED: 10,
  WEBERRORCODES_EXTERNALSTRATEGYNOTALLOWED: 11,
  WEBERRORCODES_MAXSTRATEGIESCOUNT: 12,
  WEBERRORCODES_MAXLEGSCOUNT: 13,
  WEBERRORCODES_PORTFOLIONOTFOUND: 14,
  WEBERRORCODES_DELELTEDPORTFOLIOUPDATION: 15,
  WEBERRORCODES_MAXACTIVEALGOCOUNTREACHED: 16,
  WEBERRORCODES_UTRADEORIGINALSNOTALLOWED: 17,
  WEBERRORCODES_FORWARDTESTINGNOTALLOWED: 18,
  WEBERRORCODES_INPROGRESSBACKTESTCANNOTBETERMINATED: 19,
  WEBERRORCODES_PORTFOLIODEPLOYMENTNOTALLOWED: 20,
  WEBERRORCODES_INVALIDMARGINVALUES: 21,
  WEBERRORCODES_WRONGPASSWORD: 22,
  WEBERRORCODES_USERLOCKED: 23,
  WEBERRORCODES_GLOBALEXITED: 24,
  WEBERRORCODES_STRATEGYNOTALLOWED: 25,
  WEBERRORCODES_COPYPORTFOLIONOTALLOWED: 26,
  WEBERRORCODES_EXPIREDSTRATEGY: 27,
  WEBERRORCODES_ONETIMEPLANALREADYSUBSCRIBED: 28,
  WEBERRORCODES_COUPONFORONLYNEWUSERS: 29,
  WEBERRORCODES_COUPONUTMMISMATCH: 30,
  WEBERRORCODES_COUPONINVALID: 31,
  WEBERRORCODES_COUPONSINGLEUSE: 32,
  WEBERRORCODES_COUPONLIMITEDTIMEPERIOD: 33,
  WEBERRORCODES_COUPONMAXREDEMPTIONLIMITPASSED: 34,
  WEBERRORCODES_COUPONINVALIDFORPLANID: 35,
  WEBERRORCODES_INVALIDTIME: 36,
  WEBERRORCODES_DUPLICATEPORTFOLIONAMEERROR: 37,
  WEBERRORCODES_MAX: 9999
};

/**
 * @enum {number}
 */
proto.AffiliatePermissionsTemplatesId = {
  MIN: 0,
  UMS: 1,
  LEADSTLAGENTMAPPING: 2,
  CLIENTREPORTS: 3,
  FUNDSREPORTS: 4,
  CLIENTWISEPNL: 5,
  AGENTREMARKS: 6,
  KAMUMS: 7,
  UBPC: 8,
  LEADRMMAPPING: 9,
  MAX: 100
};

/**
 * @enum {number}
 */
proto.AffiliateEntityType = {
  MIN: 0,
  ADMIN: 1,
  TL: 2,
  AGENT: 3,
  BP: 4,
  RL: 5,
  KAM: 6,
  MAX: 100
};

/**
 * @enum {number}
 */
proto.AffiliateAccessLevel = {
  NOTASSIGNED: 0,
  VIEWONLY: 1,
  FULLACCESS: 2
};

/**
 * @enum {number}
 */
proto.AffiliateAgentRemarksStatus = {
  AGENTREMARKSSTATUSMIN: 0,
  NOTCONNECTED: 1,
  CONNECTED: 2,
  DEMO: 3,
  FOLLOWUPSTATUS: 4
};

/**
 * @enum {number}
 */
proto.AffiliateAgentRemarksSubStatus = {
  AGENTREMARKSSUBSTATUSMIN: 0,
  INQUIRY: 1,
  FOLLOWUP: 2,
  NOTINTERESTED: 3,
  LANGUAGEBARRIER: 4,
  CONNECTEDNOCONVERSATION: 5,
  PLANNEGOTIATION: 6,
  SWITCHEDOFF: 7,
  INVALIDNUMBER: 8,
  WRONGNUMBER: 9,
  NOTREACHABLE: 10,
  NUMBERBUSY: 11,
  CALLDISCONNECTED: 12,
  BOOKDEMO: 13,
  DEMOGIVEN: 14,
  RINGING: 15,
  CALLBACK: 16,
  CLOSEDWON: 17,
  HOTFOLLOWUP: 18,
  NOTCONNECTEDSUBSTATUS: 19,
  CLOSEDLOST: 20
};

/**
 * @enum {number}
 */
proto.RetailLinkStatus = {
  ALL: 0,
  SINGLEACCOUNT: 1,
  MULTIPLEACCOUNTS: 2
};

/**
 * @enum {number}
 */
proto.RiskOMeterValues = {
  RISKOMETERVALUES_MIN: 0,
  RISKOMETERVALUES_CONSERVATIVE: 1,
  RISKOMETERVALUES_MODERATE: 2,
  RISKOMETERVALUES_AGGRESSIVE: 3,
  RISKOMETERVALUES_MAX: 999
};

/**
 * @enum {number}
 */
proto.PortfolioShareStatus = {
  PORTFOLIOSHARESTATUS_MIN: 0,
  PORTFOLIOSHARESTATUS_PENDING: 1,
  PORTFOLIOSHARESTATUS_ACCEPTED: 2,
  PORTFOLIOSHARESTATUS_REJECTED: 3,
  PORTFOLIOSHARESTATUS_REVOKED: 4,
  PORTFOLIOSHARESTATUS_MAX: 999
};

/**
 * @enum {number}
 */
proto.NotificaionMsgType = {
  NOTIFICAIONMSGTYPE_MIN: 0,
  NOTIFICAIONMSGTYPE_TERMINATE: 1,
  NOTIFICAIONMSGTYPE_SQAUREOFF: 2,
  NOTIFICAIONMSGTYPE_GLOBALEXIT: 3,
  NOTIFICAIONMSGTYPE_BACKTEST: 4,
  NOTIFICAIONMSGTYPE_RECURINGPAYMENTFAILED: 5,
  NOTIFICAIONMSGTYPE_PLAN_CHANGE_MESSAGE: 6,
  NOTIFICAIONMSGTYPE_FREEPLAN_EXTENSION_SUCCESS: 7,
  NOTIFICAIONMSGTYPE_FREEPLAN_EXTENSION_FAILED: 8,
  NOTIFICAIONMSGTYPE_INHOUSE_PLAN_SUBSCRIPTION_SUCCESS: 9,
  NOTIFICAIONMSGTYPE_INHOUSE_PLAN_SUBSCRIPTION_FAILED: 10,
  NOTIFICAIONMSGTYPE_INHOUSE_PLAN_SUBSCRIPTION_SUSPENDED: 11,
  NOTIFICAIONMSGTYPE_RECURRINGPAYMENTSUCCESS: 12,
  NOTIFICAIONMSGTYPE_NEWPLANADDED: 13,
  NOTIFICAIONMSGTYPE_MAX: 999
};

/**
 * @enum {number}
 */
proto.PlanType = {
  PLANTYPE_MIN: 0,
  PLANTYPE_ONETIME: 1,
  PLANTYPE_LIMITED_PERIOD: 2,
  PLANTYPE_FOREVER: 3,
  PLANTYPE_MAX: 999
};

/**
 * @enum {number}
 */
proto.TimelineLogsAction = {
  LEADCAPTURED: 0,
  DISPOSITIONADDED: 1,
  CHANGEOWNERTLAGENT: 2,
  CHANGEOWNERRM: 3,
  ACCOUNTLINK: 4,
  ACCOUNTUNLINK: 5
};

/**
 * @enum {number}
 */
proto.CouponType = {
  COUPONTYPE_NORMAL: 0,
  COUPONTYPE_SPECIAL: 1,
  COUPONTYPE_UTM: 2
};

/**
 * @enum {number}
 */
proto.AIAssistantType = {
  AIASSISTANTTYPE_MIN: 0,
  AIASSISTANTTYPE_STRATEGIST: 1,
  AIASSISTANTTYPE_UTRADEORIGINALHELPER: 2,
  AIASSISTANTTYPE_SUPPORT: 3,
  AIASSISTANTTYPE_STRATEGIEST_PROMPT_VALIDATOR: 4,
  AIASSISTANTTYPE_UTRADEORIGINALHELPER_PROMPT_VALIDATOR: 5,
  AIASSISTANTTYPE_SUPPORT_PROMPT_VALIDATOR: 6,
  AIASSISTANTTYPE_SCREENER_CREATOR: 7,
  AIASSISTANTTYPE_STOCK_ANALYSIS_AI_OVERVIEW: 8,
  AIASSISTANTTYPE_ONE_AI: 9,
  AIASSISTANTTYPE_EQUITY_STRATEGIST: 10,
  AIASSISTANTTYPE_ROUTER: 11,
  AIASSISTANTTYPE_MAX: 999
};

/**
 * @enum {number}
 */
proto.AIAssistantLevel = {
  DEFAULT: 0,
  WEAK: 1,
  MEDIUM: 2,
  STRONG: 3
};

/**
 * @enum {number}
 */
proto.PushNotificationType = {
  BROADCAST: 0,
  GLOBAL_EXIT: 1,
  SHARED_PORTFOLIO: 2,
  MANUAL_SQUARE_OFF: 3,
  STRATEGY: 4,
  PNL_REPORTS: 5,
  BROKER_CONNECTION_UPDATE: 6,
  BROKER_LOGIN_UPDATE: 7
};

goog.object.extend(exports, proto);
